import { render } from "./HeaderPhone.vue?vue&type=template&id=4c66ee7c&scoped=true"
import script from "./HeaderPhone.vue?vue&type=script&lang=js"
export * from "./HeaderPhone.vue?vue&type=script&lang=js"

import "./HeaderPhone.vue?vue&type=style&index=0&id=4c66ee7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c66ee7c"]])

export default __exports__